import React from "react";
import PageLoaderURL from "../img/page-loader.gif";
import DashnodeLogoWithName from "../img/Dashnode_logo_with_name.png";
import { AppShell } from "../AppShell";

const PrivateLayout = ({
	Component,
}: {
	Component: React.LazyExoticComponent<React.FC<any>>;
}) => {
	const [notification, setNotification] = React.useState([]);

	return (
		<AppShell
			children={Component}
			imageURL={DashnodeLogoWithName}
			pageLoaderURL={PageLoaderURL}
			notifications={notification}
			navigateToDoc={() => {}}
		/>
	);
};

export default PrivateLayout;
